import Icon from 'veui/components/Icon'
import { IconCheckCircle } from 'dls-icons-vue'

Icon.register('check-circle', IconCheckCircle)
